import { fetchUserDetails } from "../../helpers"
import { isTveEnabled } from "../helper"
import { parseJSON } from "../utils/parseJSON"
import { getPlanIdFromQueryParams } from "../Viewplans02/helper"

const structuredPlan = (plan,subscriptionPopupFonts) => {
  let planDetails = plan?.planDetails?.length ? plan.planDetails[0] : {}
  return {
      title: plan?.name || planDetails?.title,
      subTitle: plan?.description || planDetails?.description || "",
      amount: planDetails?.recurringPaymentAmount || planDetails?.purchaseAmount,
      currency: planDetails?.recurringPaymentCurrencyCode,
      cycleType : plan?.renewalCycleType ? plan?.renewalCycleType === "MONTH" ? "mo" : "yr" : null,
      features : structurePlanFeatures(plan),
      plansDetail: planDetails,
      subscriptionPopupFonts,
      planId : plan?.monetizationModel === "TVE" ? "TVE" : plan?.id,
      identifier : plan?.identifier,
      type : plan?.monetizationModel === "SVOD" ? 'Svod' : planDetails?.isRentEnabled ? 'Rent' : plan?.monetizationModel === "TVE" || plan?.type === "TVE" ? "TVE" : 'Buy', 
      description : plan?.description
    }
}
const fromulatePlanIds = (plans) => {
  //* to handle both contentplans or entitlement plans
  let planGroupList = JSON.parse(localStorage.getItem("planGroupList"))
  let monetisationPlans = plans?.length ? plans?.filter((content) => content?.type === "SVOD" || content?.monetizationModel == "SVOD") : []
  let monetisationPlansIds = monetisationPlans.map((plan) => plan?.planIds || plan?.id)
  let monetisationGroupIds = monetisationPlans.map((plan) => plan?.planGroupIds)
  monetisationGroupIds?.forEach((groupId) => {
    if(groupId) {
      monetisationPlansIds.push(planGroupList[groupId])
    }
})

return [...monetisationPlansIds.flat()]

}
const fetchTveLoggedIn = async () => {
  const { user } = await fetchUserDetails();
  const isTveLoggedIn = !!(user?.tveProvider || user?.tveMetadata?.tveProvider);
  return isTveLoggedIn
}
const handlePlanStructure = ({ metadataMap, plans, subscriptionPopupFonts }) => {
  let plansObj = {}
  let svodCounter = 0
  let rentCounter = 0
  let buyCounter = 0
  let currentStoredPlan = fetchCurrentPlan()
  plans?.map((plan, i) => {
    // if (currentStoredPlan?.planId === plan?.id) return
    let features = structurePlanFeatures(plan)
    let planDetails = plan?.planDetails?.length ? plan?.planDetails[0] : []
    if (plan?.monetizationModel === "SVOD") {
      svodCounter++
      plansObj[`SVOD-${svodCounter}`] = {
        title: plan?.name || planDetails?.title,
        subTitle: plan?.description || planDetails?.description || "",
        amount: planDetails?.recurringPaymentAmount,
        currency: planDetails?.recurringPaymentCurrencyCode,
        cycleType : plan?.renewalCycleType ? plan?.renewalCycleType === "MONTH" ? "mo" : "yr" : null,
        features,
        plansDetail: plan?.planDetails[0],
        subscriptionPopupFonts,
        planId : plan?.id,
        type : 'Svod',
        identifier : plan?.identifier,
        description : plan?.description
      }
    }
    if (plan?.monetizationModel === "TVOD") {
      let genericMessageList = window?.app_data?.appcmsMain?.genericMessages
      let purchase = genericMessageList?.buy
      let rent = genericMessageList?.rent
      let isSplitPlan = plan?.planDetails[0]?.isRentEnabled && plan?.planDetails[0]?.isPurchaseEnabled ? true : false
      if (isSplitPlan) {
        rentCounter++
        plansObj[`Rent-${rentCounter}`] = {
          title: rent,
          subTitle: planDetails?.rentalPeriodValue ? `${metadataMap?.rentSubText} ${planDetails?.rentalPeriodValue} ${planDetails?.rentalPeriodUnit}` : metadataMap?.rentSubText,
          amount: planDetails?.rentAmount || "",
          currency: planDetails?.recurringPaymentCurrencyCode,
          cycleType : plan?.renewalCycleType ? plan?.renewalCycleType === "MONTH" ? "mo" : "yr" : null,
          plansDetail: plan?.planDetails[0],
          subscriptionPopupFonts,
          planId : plan?.id,
          type : 'Rent',
          identifier : plan?.identifier,
          description : plan?.description
        }
        buyCounter++
        plansObj[`Buy-${buyCounter}`] = {
          title: purchase,
          subTitle: metadataMap?.oneTimePurchaseText,
          amount: planDetails?.purchaseAmount || "",
          currency: planDetails?.recurringPaymentCurrencyCode,
          cycleType : plan?.renewalCycleType ? plan?.renewalCycleType === "MONTH" ? "mo" : "yr" : null,
          plansDetail: plan?.planDetails[0],
          subscriptionPopupFonts,
          planId : plan?.id,
          type : 'Buy',
          description : plan?.description,
          identifier : plan?.identifier
        }
      } else {
        if (plan?.planDetails[0]?.isRentEnabled) {
          rentCounter++
          plansObj[`Rent-${rentCounter}`] = {
            title: rent,
            subTitle: planDetails?.rentalPeriodValue ? `${metadataMap?.rentSubText} ${planDetails?.rentalPeriodValue} ${planDetails?.rentalPeriodUnit}` : metadataMap?.rentSubText,
            amount: planDetails?.rentAmount || "",
            currency: planDetails?.recurringPaymentCurrencyCode,
            cycleType : plan?.renewalCycleType ? plan?.renewalCycleType === "MONTH" ? "mo" : "yr" : null,
            plansDetail: plan?.planDetails[0],
            subscriptionPopupFonts,
            planId : plan?.id,
            type : 'Rent',
            identifier : plan?.identifier,
            identifier : plan?.identifier
          }
        } else {
          buyCounter++
          plansObj[`Buy-${buyCounter}`] = {
            title: purchase,
            subTitle: metadataMap?.oneTimePurchaseText,
            amount: planDetails?.purchaseAmount || "",
            currency: planDetails?.recurringPaymentCurrencyCode,
            cycleType : plan?.renewalCycleType ? plan?.renewalCycleType === "MONTH" ? "mo" : "yr" : null,
            plansDetail: plan?.planDetails[0],
            subscriptionPopupFonts,
            planId : plan?.id,
            type : 'Buy',
            identifier : plan?.identifier,
            identifier : plan?.identifier
          }
        }
      }
    }
  })
  return plansObj
}
const structurePlanFeatures = (plan) => {
  // list all features
  if (!plan?.planDetails?.length) return []
  let features = plan?.planDetails[0]?.featureDetails?.map((f) => {
    if (f.value === 'N') {
      return {featureValue : f.textToDisplay, featureStatus : 'N'};
    } else {
      let featureValue = f.value === 'Y' ? {featureValue : f.textToDisplay, featureStatus : 'Y'} : {featureValue : `${f.textToDisplay}`, featureStatus : f.value};
      return featureValue
    }
  })
  return features
}

const fetchCurrentPlan = () => {
  let currentStoredPlan = parseJSON(sessionStorage.getItem('currentPlan'))
  if (currentStoredPlan) return currentStoredPlan
  return false
}

let svodCounter = 1
let rentCounter = 1
let buyCounter = 1
let tveCounter = 1
let currentStoredPlanAdded = false

const handlePlans = ({ plansObj, ctaType, type, isPrimaryPlanAdded, isTvePlan,metadataMap,subscriptionPopupFonts, isSecondaryPlanAdded }) => {
  let structuredPlansList = []
  let currentStoredPlan = parseJSON(sessionStorage.getItem("currentPlan"))
  if (ctaType?.type === "SVOD") {
    let plan = plansObj[`${ctaType?.type}-${svodCounter}`]
      // if ((currentStoredPlan?.planId || currentStoredPlan?.id) && !currentStoredPlanAdded) {
      //   currentStoredPlanAdded = true
      //   structuredPlansList.push(currentStoredPlan)
      // }else {
        if (plan) {
          structuredPlansList.push(plan)
          delete plansObj[`${ctaType?.type}-${svodCounter}`]
        }
      // }
      svodCounter += 1
      if (type === "primary") isPrimaryPlanAdded = true
      if (type === "secondary") isSecondaryPlanAdded = true
  } else if (ctaType?.type === "Rent") {
    let plan = plansObj[`${ctaType?.type}-${rentCounter}`]
    if (plan) {
      structuredPlansList.push(plan)
      delete plansObj[`${ctaType?.type}-${rentCounter}`]
      rentCounter += 1
      if (type === "primary") isPrimaryPlanAdded = true
      if (type === "secondary") isSecondaryPlanAdded = true
    }
  } else if (ctaType?.type === "Buy") {
    let plan = plansObj[`${ctaType?.type}-${buyCounter}`]
    if (plan) {
      structuredPlansList.push(plan)
      delete plansObj[`${ctaType?.type}-${buyCounter}`]
      buyCounter += 1
      if (type === "primary") isPrimaryPlanAdded = true
      if (type === "secondary") isSecondaryPlanAdded = true
    }
  } else if (ctaType?.type === "TVE"){
    // if (currentStoredPlan?.planId === "TVE" && currentStoredPlanAdded) return { structuredPlansList, isPrimaryPlanAdded, isSecondaryPlanAdded }
      handleTvePlan({isTvePlan,structuredPlansList, metadataMap,subscriptionPopupFonts})
      if (type === "primary") isPrimaryPlanAdded = true
      if (type === "secondary") isSecondaryPlanAdded = true
  }
  return { structuredPlansList, isPrimaryPlanAdded, isSecondaryPlanAdded }
}

const handleTvePlan = ({isTvePlan,structuredPlansList,metadataMap,subscriptionPopupFonts}) => {
  if (tveCounter > 1) return
  let isTveEnable = isTveEnabled()
  if (isTveEnable && isTvePlan) {
    let loginWithTveText = metadataMap?.loginCtaTveProvideTitle || "Login with TVE"
    let loginWithTveDescription = metadataMap?.loginCtaTveProviderDescription || "Free access with your TV credentials"
    let tvePlan = {
      title: loginWithTveText,
      subTitle: loginWithTveDescription,
      type: "TVE",
      subscriptionPopupFonts: subscriptionPopupFonts,
      planId: "TVE"
    }
    structuredPlansList.push(tvePlan)
    tveCounter +=1
  }
}

const formulatePlansStructure = ({ plans, monetisationCTA, metadataMap,subscriptionPopupFonts,isTvePlan, isCheckout }) => { //Logic to handle array that is passed to display Checkout Module Monetisation Cta's
  svodCounter = 1
  rentCounter = 1
  buyCounter = 1
  tveCounter = 1
  currentStoredPlanAdded = false
  let queryPlanId = getPlanIdFromQueryParams(window?.location?.href)
  let isTve = isTveEnabled()
  if (isTvePlan && !queryPlanId) {
    if (isTve) {
      plans.push({
        subTitle:"Connect TV Provider",
        type:"TVE"
      })
    }
 }
  if (plans[0]?.planId === "FREE_LOGIN") {
    plans[0].title = plans[0].name
    return plans
  }
  
  let plansObj = handlePlanStructure({ plans, metadataMap,subscriptionPopupFonts })

  let primaryCTA = monetisationCTA?.primaryCTA
  let secondaryCTA = monetisationCTA?.secondaryCTA
  let structuredPlansList = []
  let isPrimaryPlanAdded = false

  if (queryPlanId === "TVE" || queryPlanId === "tve" || (plans?.[0]?.type == "TVE")) {
    let primaryPlan = handlePlans({ plansObj, ctaType: {type : "TVE"}, type: "primary", isPrimaryPlanAdded,isTvePlan,metadataMap,subscriptionPopupFonts })
    structuredPlansList = [...primaryPlan?.structuredPlansList]
    return structuredPlansList
   }
  
  let primaryPlan = handlePlans({ plansObj, ctaType: primaryCTA, type: "primary", isPrimaryPlanAdded,isTvePlan,metadataMap,subscriptionPopupFonts })
   let isTVEAvailable = isTvePlan && isTve && tveCounter == 1
  let secondaryPlans = Object.keys(plansObj)?.length || isTVEAvailable ? secondaryCTA?.map((cta) => {
    let isSecondaryPlanAdded = false
    return handlePlans({ plansObj, ctaType: cta, type: "secondary", isSecondaryPlanAdded,isTvePlan,metadataMap,subscriptionPopupFonts })
  }) : null

  structuredPlansList = [...primaryPlan?.structuredPlansList]
  secondaryPlans?.map((plan) => {
    structuredPlansList = [...structuredPlansList, ...plan?.structuredPlansList]
  })

  // handling proxy plans
  if (!primaryPlan?.isPrimaryPlanAdded) {
    let planKeys = Object.keys(plansObj)
    if (planKeys?.length) {
      structuredPlansList.unshift(plansObj[planKeys[0]])
      delete plansObj[planKeys[0]]
    }
  }

  secondaryPlans?.forEach((plan, i) => {
    if (!plan?.isSecondaryPlanAdded) {
      let planKeys = Object.keys(plansObj)
      if (planKeys?.length) {
        structuredPlansList.splice(i + 1, 0, plansObj[planKeys[0]])
        delete plansObj[planKeys[0]]
      }
    }
  })

  // more plans handling
  let planKeys = Object.keys(plansObj)
  if (planKeys?.length) {
    let morePlan = {
      title: metadataMap?.morePurchaseText,
      type: "more",
      subscriptionPopupFonts: subscriptionPopupFonts,
      planId: "more"
    }
    structuredPlansList.push(morePlan)
  }
  return structuredPlansList
}

const formulateAllPlanIds = (data) => {
  let planGroupList = JSON.parse(localStorage.getItem("planGroupList"))
  const serviceType = window?.app_data?.appcmsMain?.serviceTypes || [];
      let monetisationPlans = data?.plans?.filter((content) => serviceType.includes(content?.type));
      let monetisationPlansIds = monetisationPlans?.map((plan) => plan?.planIds)
      let monetisationGroupIds = monetisationPlans?.map((plan) => plan?.planGroupIds)
      monetisationGroupIds?.forEach((groupId) => {
          if(groupId) {
              monetisationPlansIds.push(planGroupList[groupId])
          }
      })
      let ids = monetisationPlansIds ? monetisationPlansIds?.filter(item => item !== null && item !== undefined).join(",") : ""
      return ids
}

export { structurePlanFeatures, formulatePlansStructure, handlePlanStructure, fetchCurrentPlan, structuredPlan, formulateAllPlanIds, fetchTveLoggedIn, fromulatePlanIds }